import {
  configureStore,
  combineReducers,
  ThunkAction,
  Action,
  ThunkDispatch,
  AnyAction,
} from '@reduxjs/toolkit'
import { createWrapper } from 'next-redux-wrapper'

import { api } from '../services/api'

import campignReducer from '../features/campaign'
import organizationTagsReducer from '../features/organizationTags'
import themeReducer from '../features/theme'
import stepsReducer from '../features/steps'
import statusReducer from '../features/status'
import answersReducer from '../features/answers'
import billingDetailsReducer from '../features/billingDetails'
import dedicationReducer from '../features/dedication'
import paymentDetailsReducer from '../features/paymentDetails'
import pmStatusReducer from '../features/paymentMethodStatus'
import chargeSummaryReducer from '../features/chargeSummary'
import grossAdjustmentReducer from '../features/grossAdjustment'
import donationOptionsReducer from '../features/donationOptions'
import cartReducer from '../features/cart'
import validationReducer from '../features/validation'

/**
 * Order specific redux slices will be added to this `combineReducers` call.
 *
 * Some examples include: answers, questions, dedication, billingData, etc.
 *
 * See: https://drive.google.com/file/d/1UXJ0Fyzf3WkRjU9CwvPRo4AI3nSkepJC/view?usp=sharing
 */
const orderReducers = combineReducers({
  campaign: campignReducer,
  steps: stepsReducer,
  status: statusReducer,
  answers: answersReducer,
  billingDetails: billingDetailsReducer,
  dedication: dedicationReducer,
  paymentDetails: paymentDetailsReducer,
  pmStatus: pmStatusReducer,
  chargeSummary: chargeSummaryReducer,
  grossAdjustment: grossAdjustmentReducer,
  donationOptions: donationOptionsReducer,
  cart: cartReducer,
})

export const baseReducer = combineReducers({
  organizationTags: organizationTagsReducer,
  theme: themeReducer,
  order: orderReducers,
  validation: validationReducer,
  [api.reducerPath]: api.reducer,
})

export const makeStore = () =>
  configureStore({
    devTools: true,
    reducer: baseReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
  })

export const wrapper = createWrapper(makeStore)

export type RootState = ReturnType<typeof baseReducer>
export type AppThunk = ThunkAction<void, RootState, null, Action<string>>
export type TypedDispatch<T> = ThunkDispatch<T, unknown, AnyAction>
